
<template>
  <div>
    <mdb-modal centered @close="$store.commit('clearCurrentModal')" elegant size="lg">
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue">{{ options.title }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="d-flex flex-column pt-0">
        <h3 class="isi-sub-heading-gray mb-3">
          Standard Kitchen Utensils
          <span>&minus; The facility is equipped with enough preparation and kitchen utensils such as plates, bowls, glasses, cups, pots, pans and cutlery of the same size and type to handle projects with full capacity per session.</span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Fridges
          <span>
            &minus;
            At least 2 fridges with a total minimum capacity of 500 liters.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Freezers
          <span>
            &minus;
            At least one freezer with a total minimum capacity of 250 liters.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Electric Ovens
          <span>
            &minus;
            At least 2 electric ovens with a minimum capacity of 60 liters each.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Electric Stoves
          <span>
            &minus;
            At least one electric stove with 4 stove plates.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Gas Stoves
          <span>
            &minus;
            At least one gas stove with 4 stove plates.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Induction Hobs
          <span>
            &minus;
            At least 3 induction hobs.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Microwaves
          <span>
            &minus;
            At least 2 microwaves.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Scales
          <span>
            &minus;
            At least 3 scales with different accuracy such as 0,01g, 0,1g, 10g and 100g.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Thermometers
          <span>
            &minus;
            At least 2 digital kitchen thermometers of the same type and accuracy.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Kettles
          <span>
            &minus;
            At least 3 kettles of the same size and type.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Washing Machine / Washer
          <span>
            &minus;
            At least 2 Washing Machines / Washers of the same size and type.
          </span>
        </h3>

        <h3 class="isi-sub-heading-gray mb-3">
          Tumble Dryer / Dryer
          <span>
            &minus;
            At least 2 Tumble Dryers / Dryers of the same size and type.
          </span>
        </h3>

        <mdb-btn
          class="btn btn-isi align-self-center"
          @click.native="$store.commit('clearCurrentModal')"
        >Ok</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>